/** A public inbox and a topic only: never carry page query strings, tokens or account data into mail. */
export function supportHref(
  tenant: { name: string; support_email?: string | null | undefined },
  topic = 'Academy help',
): string | null {
  return tenant.support_email
    ? `mailto:${encodeURIComponent(tenant.support_email)}?subject=${encodeURIComponent(`${tenant.name}: ${topic}`)}`
    : null;
}
